import type { CreatorRecord } from '../types';
import { catalog, packsForCreator, profilesForCreator } from './catalog';
import { creatorActivity, type CreatorActivityItem } from './creatorActivity';
import { exampleCreatorActivity } from './exampleCreatorActivity';

/** The same published activity is used on creator pages and the following feed. */
export function activityForCreators(creators: CreatorRecord[]): CreatorActivityItem[] {
  return creators.flatMap((creator) => {
    const profiles = profilesForCreator(creator);
    const packs = packsForCreator(creator);
    return [
      ...creatorActivity(profiles, packs, catalog.profiles),
      ...exampleCreatorActivity(profiles, packs),
    ];
  }).sort((left, right) => Date.parse(right.date) - Date.parse(left.date)
    || left.record.creator.localeCompare(right.record.creator)
    || left.record.name.localeCompare(right.record.name, undefined, { numeric: true })
    || left.record.id.localeCompare(right.record.id));
}
